import {Form} from "@/models/gessan/form";
import { Lista } from "@/models/gessan/lista";
import {PaginationTableSaneamento} from "@/store/modules/gessan/states/table";

export default {
  setForm({commit}: any, value: Form): void {
    commit('SET_FORM', value)
  },
  setTableContent({commit}: any, value: Lista[]): void {
    commit('SET_TABLE_CONTENT', value)
  },
  setTableIsLoading({commit}: any, value: boolean): void {
    commit('SET_TABLE_LOADING', value)
  },
  setTableTotals({commit}: any, value: number): void {
    commit('SET_TABLE_TOTALS', value)
  },
  setTablePagination({commit}: any, value: PaginationTableSaneamento): void {
    commit('SET_TABLE_PAGINATION', value)
  },
  clearTable({commit}: any): void {
    commit('CLEAR_TABLE')
  },
}
